import React from "react";
import { withStyles } from '@material-ui/core';
import ImageChanger from "content/Event/EventVenue/imageChanger";
import Button from "storybookComponents/Button"
import defaultBanner from '../../../defaultBanner';
import "./style.css"
import TextField from '@material-ui/core/TextField';

const styles = () => ({
  changeButton: {
    width: 240,
    marginTop: 10,
    opacity: 1,
    height: 40,
    boxShadow: "none",
    background: "white",
    "&:hover": {
      background: "white !important"
    }
  },
  imageButtonContainer: {
    position: "relative",
    marginTop: 10
  },
  imageStyle: {
    width: "100%",
    minWidth: "100%",
    maxHeight: 287,
    borderRadius: 10,
  },
  notchedOutline: {
    borderColor: "#dadada",
  },
  inputStyle: {
    fontSize: "14px",
    padding: "10px 10px",
    lineHeight: "20px",
    '&:hover $notchedOutline': {
      borderColor: "#26bbed !important",
    },
    '&$focused $notchedOutline': {
      borderColor: '#999999 !important'
    }
  },
  focused: {
    // borderColor: "red !important"
  },

})

const ContentBody = ({ classes, values, type, showNotification, handleChange }) => {

  const onBlur = (e) => {
    handleChange(type, "text", e.target.value)
  }

  const updateImage = (e) => {
    handleChange(type, "image", e)
  }

  return (
    <div >
      <TextField
        multiline
        variant="outlined"
        value={values.text}
        InputProps={{
          classes: {
            notchedOutline: classes.notchedOutline,
            root: classes.inputStyle,
            focused: classes.focused
          },
        }}
        onChange={onBlur}
        fullWidth />
      <div className={`banner-container-social ${classes.imageButtonContainer}`}>
        <img src={values.image || defaultBanner} className={classes.imageStyle} />
        <div className="banner-social-media">
          <ImageChanger
            base64
            showNotification={showNotification}
            onChange={updateImage}
            customButton={
              <Button className={classes.changeButton} variant="secondary" size="md">
                CHANGE IMAGE
              </Button>
            }
          />
        </div>
      </div>
    </div >
  )
}

export default withStyles(styles)(ContentBody);